export default __webpack_public_path__ + "images/7975a8234c0e35348f81d6bdb94e43ae.png";